<template>
    <div class="image-uploader">
        <el-upload
            class="el-image-uploader"
            :action="uploadURL"
            :data="params"
            accept=".jpg,.jpeg,.bmp,.png"
            :name="field"
            list-type="picture-card"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
            :disabled="!!value"
        >
            <slot>
                <template v-if="value">
                    <img :src="value" class="image-uploader-file" alt="cover" v-viewer>
                    <div class="mask">
                        <i class="btn-preview el-icon-zoom-in" @click.stop="previewImage()" title="预览图片"></i>
                        <i class="btn-delete el-icon-delete" @click.stop="deleteImage()" title="删除图片"></i>
                    </div>
                </template>

                <template v-else>
                    <slot name="prepare">
                        <div class="prepare-upload">
                            <i class="el-icon-plus add-icon" :title="$t('course.addCover')"></i>
                            <p class="tips">上传图片</p>
                            <p class="tips">{{ $t('course.coverTip', [maxSize]) }}</p>
                        </div>
                    </slot>
                </template>
            </slot>
        </el-upload>
    </div>
</template>

<script>
import api from "@/api";
import {Ticket} from "@/utils";

/**
 *  图片上传组件，用于封面上传、头像上传等
 *  用法：
 *  <image-uploader
 *    v-model="thumbUrl"
 *    @on-success="uploadSuccess">
 *  </image-uploader>
 */
export default {
    props: {
        // 图片的地址，可直接使用v-model
        value: {
            default: ''
        },

        // 上传地址
        uploadURL: {
            default: api.fileUploadURL + '/Cover'
        },

        field: {
            default: 'upfile'
        },

        accept: {
            default: (() => {
                return ['.jpg', '.jpeg', '.bmp', '.png'].join()
            })
        },

        // 文件最大限制，单位M
        maxSize: {
            type: Number,
            default: 2
        },
    },

    data() {
        return {
            params: {
                'access_token': Ticket.get() && Ticket.get().access_token
            },
        }
    },

    methods: {
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error(this.$t('course.coverTooBigMsg'))
            } else {
                this.params.access_token = Ticket.get().access_token
            }
            return isLt2M
        },

        uploadSuccess(res, file) {
            if (res.result) {
                //this.imageUrl = res.url
                //this.$emit('on-success', this.imageUrl, file)
                let imageUrl = res.url
                this.$emit('input', imageUrl)
                this.$emit('on-success', this.imageUrl, file)
            } else {
                this.$message.error(res.message)
            }
        },

        previewImage() {
            $(`.image-uploader-file`)[0].$viewer.show()
        },

        deleteImage() {
            this.$emit('input', '')
        }

    },
}
</script>

<style lang="scss">
.image-uploader {
    .el-upload {
        position: relative;
        width: 360px;
        height: 190px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &:hover {
            .mask {
                opacity: 1;
            }

            .add-icon {
                color: $blue;
            }
        }
    }

    .prepare-upload {
        color: #bbb;

        .add-icon {
            display: block;
            //margin-top: 50px;
            margin-bottom: 20px;
            font-size: 30px;
            color: #bbb;
        }

        .tips {
            line-height: 1.6;
            font-size: 12px;
        }
    }

    .image-uploader-file {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .mask {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, .5);
        opacity: 0;
        transition: opacity .3s;
        cursor: default;

        i {
            color: #fff;
            font-size: 22px;
            cursor: pointer;

            + i {
                margin-left: 50px;
            }

            &:hover {
                color: $blue;
            }
        }
    }

}
</style>
